import React from 'react'
import { Icon as RIKIcon } from 'react-icons-kit'
import type { IconProp as RIKIconProps } from 'react-icons-kit'
import cx from 'classnames'

import styles from './Icon.module.scss'

export * from './model'

type IconSource = string | RIKIconProps['icon']

type IconProps = {
  ariaLabel?: string
  className?: string
  icon: IconSource
  onClick?: React.MouseEventHandler<HTMLElement>
  size?: number
  style?: React.CSSProperties
  title?: string
}

const isAssetIcon = (icon: IconSource): icon is string => typeof icon === 'string'

export const Icon = React.forwardRef<HTMLElement | HTMLImageElement, IconProps>(
  ({ ariaLabel, className, onClick, icon, size = 16, style, title }, ref) => {
    if (isAssetIcon(icon)) {
      return (
        <img
          alt={ariaLabel || title || ''}
          className={cx(styles.icon, styles.assetIcon, className)}
          height={size}
          onClick={onClick}
          ref={ref as React.Ref<HTMLImageElement>}
          src={icon}
          style={style}
          title={title}
          width={size}
        />
      )
    }

    return (
      <span
        aria-label={ariaLabel}
        className={cx(styles.icon, className)}
        onClick={onClick}
        ref={ref as React.Ref<HTMLSpanElement>}
        role="img"
        style={style}
        title={title}
      >
        <RIKIcon {...{ icon, size, title }} />
      </span>
    )
  },
)

